import { pythonVmInstance } from "utils/AxiosInstances/RareboxPythonInstance";

export const PAGE_SIZE = 31;

export const getTargetVsAchievedPivot = async (params = {}) => {
	const { data } = await pythonVmInstance.get("/reports/target-vs-achieved/pivot", { params });
	return data;
};

export const getTargetVsAchievedTargetsMeta = async () => {
	const { data } = await pythonVmInstance.get("/reports/target-vs-achieved/targets/meta");
	return data;
};

export const uploadTargetVsAchieved = async ({ file, replace = true, email = "" } = {}) => {
	const form = new FormData();
	form.append("file", file);
	if (replace) {
		form.append("replace", "true");
	}
	if (email) {
		form.append("email", email);
	}
	const { data } = await pythonVmInstance.post("/reports/target-vs-achieved/upload", form, {
		headers: { "Content-Type": "multipart/form-data" },
	});
	return data;
};
